import type { RegisterSearch } from "../routes/register"

export const getCookie = (cookieName: string) => {
  const name = `${cookieName}=`
  const cookieArray = document.cookie.split(';')
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i]
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1)
    }
    if (cookie.indexOf(name) === 0) {
      const value = cookie.substring(name.length, cookie.length)
      // A malformed %-sequence in any third-party cookie must not throw
      // (this runs inside the root bootstrap); fall back to the raw value.
      try {
        return decodeURIComponent(value)
      } catch {
        return value
      }
    }
  }
  return ''
}

export const getAdsInfo = (): RegisterSearch => {
  try {
    const adsInfo = JSON.parse(
      localStorage.getItem('ads_info') ?? '{}',
    ) as RegisterSearch
    return adsInfo
  } catch (error) {
    return {}
  }
}
